import { memo, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { ContentWrapper } from '../../_common';
import srv from '../../../services';
import moment from 'moment';
import SelectContractAis from '../../_common/SelectContractAis';
import { Select } from 'antd';
import { SelectBlock } from '../MeteringDevices.styled';
import { makeStyles } from '@material-ui/core/styles';
import { DatePicker, Space } from 'antd';
import { SubmitButton, DownloadButton } from './MeteringOrders.styled';
import {
 Content,
 Contract,
 ContractData,
 ContractZoom,
 ContractType,
 ContractNumber,
 PrintNumber,
 ContractParam,
} from './Contracts.styled';
import MeteringDevice from '../../../models';
import { ZoomInIcon, ZoomOutIcon } from '../../_assests';
import { BaseForm, Col } from './PaymentDocuments.styled';
import { Form, Input, Alert, Popconfirm } from 'antd';
import Snackbar from '@mui/material/Snackbar';

const { RangePicker } = DatePicker;

const useStyles = makeStyles({
 container: {
  display: 'flex',
  flexDirection: 'row',
  overflow: 'auto',
  marginLeft: '80px',
  marginRight: '80px',
  marginTop: '40px',
  width: 'calc(100% - 160px)',
  cursor: 'default',
  overflowX: 'auto',
  overflowY: 'auto',
  height: '100%',
  fontSize: '35px',
  fontWeight: 600,
 },
});

const MeteringOrders = () => {
 const classes = useStyles();

 const [form] = Form.useForm();

 const [contractAisId, setContractAisId] = useState<string>(null);
 const [contractId, setContractId] = useState<string>(null);
 const [applicationMeteringDeviceData, setApplicationMeteringDeviceData] =
  useState<[]>(null);

 const [applicationNumber, setApplicationNumber] = useState(null);

 const [maximized, setMaximized] = useState<boolean>(false);
 const [maximizedId, setMaximizedId] = useState<string>();

 const [snackBarOpen, setSnackBarOpen] = useState(false);
 const [snackBarMessage, setSnackBarMessage] = useState('');
 const [snackBarType, setSnackBarType] = useState('error');
 const [dateFrom, setDateFrom] = useState('');
 const [dateTo, setDateTo] = useState('');
 const [documentFilteredData, setDocumentFilteredData] = useState([]);
 const [selectedCard, setSelectedCard] = useState<any>();

 const contractsData =
  useQueryClient().getQueryData<Models.Contract[]>('contracts');

 let documentsData = useQueryClient().getQueryData<Models.Dict[]>('documents');

 useEffect(() => {
  if (documentsData && documentsData.length > 0) {
   let filteredData = [];

   documentsData.map((record: any) => {
    if (
     record.name === 'Акт допуска ПУ в эксплуатацию + фотографии' ||
     record.name === 'Акт проверки ПУ + фотографии' ||
     record.name === 'Акт снятия ПУ + фотографии' ||
     record.name === 'Акт о введении ограничения'
    ) {
     filteredData.push(record);
    }
   });

   setDocumentFilteredData(filteredData);

   // Акт допуска ПУ в эксплуатацию
   // Акт проверки ПУ
   // Акт снятия ПУ
   // Акт о введении ограничения
  }
 }, [documentsData]);

 const changeContract = (value) => {
  setContractAisId(value);
 };

 const handleButtonSubmitClick = () => {
  setMaximized(false);

  const contractIdFound = contractsData;

  moment.locale('ru');
  const payload = {
   contractId: contractAisId,
   startDate: moment(dateFrom, 'DD.MM.YYYY HH:mm:ss'),
   endDate: moment(dateTo, 'DD.MM.YYYY HH:mm:ss'),
  };

  srv.getApplicationMeteringDevice(payload).then((response: any) => {
   if (response && response?.requests && response?.requests?.length > 0) {
    setApplicationMeteringDeviceData(response.requests);
   } else {
    setSnackBarMessage('Нет данных');
    setSnackBarType('success');
    setSnackBarOpen(true);

    setApplicationMeteringDeviceData(null);
   }
  });
 };

 const maximize = (value: string) => {
  if (maximized && maximizedId === value) {
   setMaximizedId(value);
   setApplicationNumber(value);
   setMaximized(false);
  }

  if (maximized && maximizedId !== value) {
   setMaximizedId(value);
   setApplicationNumber(value);
   setMaximized(true);
   form.resetFields();
  }

  if (!maximized) {
   setMaximizedId(value);
   setApplicationNumber(value);
   setMaximized(true);
   form.resetFields();
  }

  setSelectedCard(value);
 };

 const handleDownloadActClick = (dataForm: any) => {
  dataForm.submit();
  const fields = dataForm.getFieldValue();

  if (!fields) {
   setSnackBarMessage('Не все обязательные поля заполнены');
   setSnackBarType('warning');
   setSnackBarOpen(true);

   return;
  }

  let saveObject: any = {};

  if (
   applicationMeteringDeviceData &&
   applicationMeteringDeviceData.length > 0 &&
   selectedCard
  ) {
   const selectedData: any = applicationMeteringDeviceData.filter(
    (x: any) => x.applicationNumber === selectedCard,
   );

   if (selectedData && selectedData.length > 0) {
    saveObject = {
     contractId: contractAisId,
     eMail: fields.eMail,
     documentsType: [4, 5, 6, 7, 8],
     startDate: selectedData[0].applicationDate,
     endDate: selectedData[0].applicationDate,
     applicationNumber: applicationNumber,
    };
   }
  }

  if (
   saveObject.contractId &&
   saveObject.eMail &&
   saveObject.documentsType &&
   saveObject.startDate &&
   saveObject.endDate
  ) {
   srv
    .requestDocuments(saveObject)
    .then((response) => {
     if (response) {
      setSnackBarMessage('Запрос успешно отправлен');
      setSnackBarType('success');
      setSnackBarOpen(true);
      form.resetFields();
     } else {
      setSnackBarMessage('Ошибка отправки запроса');
      setSnackBarType('error');
      setSnackBarOpen(true);
     }
    })
    .catch(() => {
     setSnackBarMessage('Ошибка отправки запроса');
     setSnackBarType('error');
     setSnackBarOpen(true);
    });
  } else {
   setSnackBarMessage('Не все обязательные поля заполнены');
   setSnackBarType('error');
   setSnackBarOpen(true);
  }
 };

 const handleSnackBarClose = () => {
  setSnackBarOpen(false);
 };

 const handlePeriodChange = (e: any) => {
  if (e && e.length > 1) {
   const startDate = moment(e[0]).format('DD.MM.YYYY');
   const endDate = moment(e[1]).format('DD.MM.YYYY');

   setDateFrom(startDate);
   setDateTo(endDate);
  }
 };

 return (
  <div
   style={{
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '800px',
    position: 'absolute',
    padding: 0,
   }}
  >
   <div
    className={classes.container}
    style={{
     display: 'flex',
     flexDirection: 'row',
     overflow: 'hidden',
     height: '200px',
     marginTop: '120px',
     marginBottom: '-70px',
    }}
   >
    <SelectBlock>
     <SelectContractAis
      changeContract={changeContract}
      contracts={contractsData}
      value={contractAisId}
     />
    </SelectBlock>
    <Space direction="vertical" size={12}>
     <RangePicker onChange={handlePeriodChange} />
    </Space>

    <SubmitButton
     htmlType="submit"
     onClick={handleButtonSubmitClick}
     disabled={false}
    >
     Запросить
    </SubmitButton>
   </div>

   <div
    style={{
     display: 'flex',
     flexDirection: 'row',
     overflow: 'auto',
     height: '500px',
     marginTop: '-30px',
    }}
   >
    <ContentWrapper>
     <Content>
      {applicationMeteringDeviceData?.map(
       (meteringDeviceData: MeteringDevice) => (
        <Contract
         key={meteringDeviceData.aisId}
         style={{
          width:
           maximized && meteringDeviceData.applicationNumber === maximizedId
            ? '750px'
            : '300px',
         }}
        >
         {meteringDeviceData &&
          meteringDeviceData.status &&
          meteringDeviceData.status.toLowerCase() === 'завершена' && (
           <ContractZoom
            onClick={() => maximize(meteringDeviceData.applicationNumber)}
           >
            {maximized ? <ZoomOutIcon /> : <ZoomInIcon />}
           </ContractZoom>
          )}

         <ContractData>
          <ContractType>
           <div
            style={{
             display: 'flex',
             flexDirection: 'row',
             justifyContent: 'space-between',
             width:
              maximized && meteringDeviceData.applicationNumber === maximizedId
               ? '750px'
               : '300px',
            }}
           >
            <div>
             <u>Номер заявки</u> {meteringDeviceData.applicationNumber}
            </div>
           </div>
          </ContractType>

          <PrintNumber>
           <u>Дата создания</u>{' '}
           {moment(meteringDeviceData.applicationDate).format('DD.MM.YYYY')}
          </PrintNumber>

          <ContractParam>
           <u>Вид заявки</u> {meteringDeviceData.type}
          </ContractParam>

          <ContractParam>
           <u>Статус</u> {meteringDeviceData.status}
          </ContractParam>

          <ContractParam>
           <u>Дата планового выполнения с</u>{' '}
           {moment(meteringDeviceData.fromDate).format('DD.MM.YYYY')}
          </ContractParam>

          <ContractParam>
           <u>Дата планового выполнения по</u>{' '}
           {moment(meteringDeviceData.toDate).format('DD.MM.YYYY')}
          </ContractParam>
         </ContractData>
         {maximized && meteringDeviceData.applicationNumber === maximizedId && (
          <div
           style={{
            display: 'flex',
            flexDirection: 'column',
            height: '350px',
            width: '425px',
            marginTop: '50px',
           }}
          >
           <BaseForm layout="vertical" form={form}>
            {/* <Col>
             <Form.Item
              name="contractId"
              label="№ Договора"
              rules={[{ required: true }]}
             >
              <Select
               style={{ width: '200px' }}
               showSearch
               optionFilterProp="children"
               placeholder="Выберите № договора"
              >
               {contractsData?.map((item) => (
                <Select.Option key={item.id} value={item.aisId}>
                 {`${item.printNumber} - ${item.resources}`}
                </Select.Option>
               ))}
              </Select>
             </Form.Item>
            </Col> */}

            {/* <Col flex={2}>
             <Form.Item
              name="period"
              label="Период запроса"
              rules={[{ required: true }]}
              style={{ width: '300px' }}
             >
              <RangePicker
               allowClear
               format="DD.MM.YYYY"
               style={{ width: '100%' }}
              />
             </Form.Item>
            </Col> */}

            <Col flex={2}>
             {/* <Form.Item
              name="documentsType"
              label="Тип запрашиваемого документа"
              rules={[{ required: true }]}
              style={{ width: '350px' }}
             >
              <Select
               mode="multiple"
               showSearch
               optionFilterProp="children"
               placeholder="Выберите тип документа"
              >
               {documentFilteredData?.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                 {item.name}
                </Select.Option>
               ))}
              </Select>
             </Form.Item> */}

             <Form.Item
              name="eMail"
              label="E-mail"
              rules={[{ required: true }]}
              style={{ width: '350px' }}
             >
              <Input placeholder="Введите E-mail" />
             </Form.Item>
            </Col>

            {meteringDeviceData &&
             meteringDeviceData.status &&
             meteringDeviceData.status.toLowerCase() === 'завершена' && (
              <Col flex={2}>
               <DownloadButton
                disabled={false}
                onClick={() => handleDownloadActClick(form)}
               >
                Скачать Акт
               </DownloadButton>
              </Col>
             )}
           </BaseForm>
          </div>
         )}
        </Contract>
       ),
      )}
     </Content>
    </ContentWrapper>
   </div>
   <Snackbar
    open={snackBarOpen}
    autoHideDuration={2000}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    message={snackBarMessage}
    onClose={handleSnackBarClose}
    sx={{
     backgroundColor:
      applicationMeteringDeviceData && applicationMeteringDeviceData.length > 0
       ? 'black'
       : 'green',
     color: 'white',
    }}
   ></Snackbar>
  </div>
 );
};

export default memo(MeteringOrders);
